import EventEmitter from '../common/EventEmitter';
import { ApiEvents, KsdkEventData } from '@kollective-frontend/ksdk-api';
import {
  BitrateRangeEvent,
  TransferSummaryEvent
} from '@kollective-frontend/ksdk-api/events';
import { PrimingEvent } from '../reporter/constants';
import { StdPlayerEvents } from '../common/Reporter/constants';
import {
  InitializeReporterData,
  InterceptorChangeEvent,
  InternalEvents,
  ReporterEvent,
  SourceSetEventOptions
} from '../events';
import { MaybeContentConfig } from '../config/ContentConfig';
import { MaybeLocalState } from '../state/LocalState';
import { PlayerEvent, DetectionEvent } from '../reporter/constants';
import { TriggerAction } from '../common/Reporter/interfaces';
import logger from '../log';
const log = logger.getLogger(__filename);

// Wrapped to allow unit tests to mock out the emitter.
const emitter = () => EventEmitter.getInstance();

export const dispatchConfigUpdate = (data: MaybeContentConfig): void => {
  emitter().dispatch({ type: InternalEvents.CONFIG_UPDATE, data });
};

export const dispatchSourceSetEvent = (data: SourceSetEventOptions): void => {
  emitter().dispatch({ type: InternalEvents.SOURCE_SET, data });
};

export const dispatchError = (reason: string | KsdkEventData): void => {
  const data = typeof reason === 'string' ? { reason } : reason;
  emitter().dispatch({ type: ApiEvents.ERROR, data });
};

export const dispatchDetectionEvent = (data: DetectionEvent): void => {
  emitter().dispatch({ type: InternalEvents.DETECTION_EVENT, data });
};

export const dispatchPlayerEvent = (data: PlayerEvent): void => {
  emitter().dispatch({ type: InternalEvents.PLAYER_EVENT, data });
};

export const dispatchPrimingEvent = (data: PrimingEvent): void => {
  emitter().dispatch({ type: InternalEvents.PRIMING_EVENT, data });
};

export const dispatchTriggerEvent = (action: TriggerAction): void => {
  const data = { action };
  emitter().dispatch({ type: InternalEvents.TRIGGER, data });
};

export const dispatchUpdateReportEvent = (data: ReporterEvent): void => {
  emitter().dispatch({ type: InternalEvents.UPDATE_REPORT, data });
};

export const dispatchInitializeReporter = (
  data: InitializeReporterData
): void => {
  emitter().dispatch({ type: InternalEvents.INITIALIZE_REPORTER, data });
};

export const dispatchUpdateStateEvent = (data: MaybeLocalState): void => {
  emitter().dispatch({ type: InternalEvents.UPDATE_STATE, data });
};

export const dispatchIfValidDuration = (dur?: number): void => {
  if ((typeof dur === 'number' && dur > 0) || dur === -1) {
    const e = StdPlayerEvents.durationchange.code;
    emitter().dispatch({
      type: InternalEvents.PLAYER_EVENT,
      data: { e, dur, synthetic: true }
    });
  }
};

export const dispatchBitrateRangeEvent = async (
  data: BitrateRangeEvent['data']
): Promise<void> => {
  await emitter().dispatch({ type: ApiEvents.BITRATE_RANGE_EVENT, data });
};

export const dispatchInterceptorChangeEvent = (
  data: InterceptorChangeEvent
): void => {
  emitter().dispatch({ type: InternalEvents.INTERCEPTOR_CHANGE, data });
};

export const dispatchTransferSummaryEvent = (
  data: TransferSummaryEvent
): void => {
  emitter()
    .dispatch({ type: ApiEvents.TRANSFER_SUMMARY, data })
    .catch(e => log.warn('Error dispatching event:', e));
};
